<template>
    <div>
        <ul class="main-menu-bar visible" style="margin: 0">
                <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 0 == activeTab}]" tag="li" @click="changeTab(0)">
                        <IconButton :text="$t('STATUS')">
                            <img src="~@/assets/img/Menu/Systems.svg" />
                        </IconButton>
                    </div>
                </div>
                <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 5 == activeTab}]" tag="li" @click="changeTab(5)">
                        <IconButton :text="$t('SENSORS')">
                            <img src="~@/assets/img/Menu/Sensors.svg" />
                        </IconButton>
                    </div>
                </div>
                <!-- <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 1 == activeTab}]" tag="li"  @click="changeTab(1)">
                        <IconButton :text="$t('HIGH')">
                            <img src="~@/assets/img/Menu/Alarms.svg" />
                        </IconButton>
                    </div>
                </div>
                <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 2 == activeTab}]" tag="li"  @click="changeTab(2)">
                        <IconButton :text="$t('MID')">
                            <img src="~@/assets/img/Menu/Alarms.svg" />
                        </IconButton>
                    </div>
                </div>
                <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 3 == activeTab}]" tag="li"  @click="changeTab(3)">
                        <IconButton :text="$t('LOW')">
                            <img src="~@/assets/img/Menu/Alarms.svg" />
                        </IconButton>
                    </div>
                </div> -->
                <!-- <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 4 == activeTab}]" tag="li"  @click="changeTab(4)">
                        <IconButton :text="$t('PER_DEVICE')">
                            <img src="~@/assets/img/Systems/Device_white.svg" />
                        </IconButton>
                    </div>
                </div> -->
            </ul>
        <div class="chart">
            <div v-if="spin == true" class="mySpinner">
                <Spinner style="width: 100%; position: fixed; top: 50vh;"></Spinner>
            </div>
            <sci-chart-sensors-data ref="c-5" v-if="activeTab == 5" :systemId="data.id" :sid="5"/>
            <sci-chart-device-status ref="c-0" v-else-if="activeTab == 0" :activeSet="activeTab" :systemId="data.id" :originaldata="originalData" :dataset="statusChartData" :initialZoomOut="true" :sid="0"></sci-chart-device-status>
            <!-- <sci-chart-multiple-overview ref="c-1" v-else-if="activeTab < 4 && activeTab > 0" :allAlarmTypes="allAlarmTypes.filter(x => parseInt(x.priority) == activeTab).map(x => x.description)" :activeSet="activeTab" :dataset="dataset" :devices="devices" :systemId="data.id" :initialZoomOut="true" :sid="1"></sci-chart-multiple-overview> -->
            <!-- <sci-chart-per-device ref="c-2" v-else-if="activeTab == 4" @spin="(v) => spin = v" :initialZoomOut="true" :systemId="data.id" :sid="2" :activeSet="activeTab" :allAlarmTypes="allAlarmTypes"></sci-chart-per-device> -->
        </div>
    </div>
</template>

<script>
import { getSystemAlarmsByPriorityFromWeek, getAllAlarmTypes, getDeviceStatusFromDatesToChart } from '@/api/api'
import SciChartMultipleOverview from '../Charts/SciChartMultipleOverview.vue'
import SciChartMultiple from '../SciChartMultiple.vue'
import SciChartDeviceStatus from '../Charts/SciChartDeviceStatus.vue'
import Spinner from 'vue-simple-spinner'
import IconButton from '@/components/IconButton'
import SciChartPerDevice from '../Charts/SciChartPerDevice.vue'
import SciChartSensorsData from '../Charts/SciChartSensorsData.vue'

export default {
    props: {
        data: {
            required: true
        }
    },
    components: {
        SciChartMultipleOverview,
        SciChartMultiple,
        SciChartDeviceStatus,
        Spinner,
        IconButton,
        SciChartPerDevice,
        SciChartSensorsData
    },
    data() {
        return {
            init: false,
            dataset: [],
            statusChartData: [],
            originalData: [],
            allAlarmTypes: [],
            devices: 0,
            spin: false,

            activeTab: 0,
            // tabHeaders: ['STATUS', 'HIGH LEVEL ALARM', 'MID LEVEL ALARM', 'LOW LEVEL ALARM']
        }
    },
    methods: {
        async processData() {
            this.processStatusChart()

            this.init = true;
        },
        async processStatusChart() {
            this.spin = true
            var res = await this.genericProcessStatus()

            res.forEach((e, i) => {
                e.values.forEach((f, j) => {
                    if(f == -1){
                        res[i].values[j] = NaN
                    }
                    res[i].dates[j] = new Date(res[i].dates[j])
                })
            })

            this.statusChartData = res;
            this.spin = false
        },
        processHighLevelChart(highData) {
            this.highChartData = this.genericProcess(highData)
        },
        processMidLevelChart(midData) {
            this.midChartData = this.genericProcess(midData)
        },
        processLowLevelChart(lowData) {
            this.lowChartData = this.genericProcess(lowData)            
        },
        async genericProcessStatus() {
            var dateWeekAgoTemp = new Date();
            dateWeekAgoTemp.setDate(dateWeekAgoTemp.getDate() - 7)
            dateWeekAgoTemp = new Date(dateWeekAgoTemp.getFullYear(), dateWeekAgoTemp.getMonth(), dateWeekAgoTemp.getDate())

            var res = await getDeviceStatusFromDatesToChart(this.data.id, dateWeekAgoTemp, new Date())
            return res;
        },
        async changeTab(tabNumber){
            if(this.activeTab != tabNumber && this.init){
                this.activeTab = tabNumber

                if(tabNumber < 4 && tabNumber > 0){
                    this.spin = true
                    var result = await getSystemAlarmsByPriorityFromWeek(this.data.id, tabNumber)

                    if(result.chartData.length != result.numberOfDevices ) {
                        var availableDevices = result.chartData.map(x => x.item2)

                        for(let i = 1; i <= result.numberOfDevices; i++){
                            if(!availableDevices.includes(i.toString())){
                                result.chartData.push({item1: [], item2: i.toString()})
                            }
                        }
                    }

                    this.devices = result.numberOfDevices
                    this.dataset = result.chartData

                    this.spin = false
                }
            }
        },
        async loadAllAlarmTypes() {
            var aT = await getAllAlarmTypes()
            this.allAlarmTypes = aT;
        }
    },
    mounted: async function() {
        this.processData()
        this.loadAllAlarmTypes()
    },
    beforeDestroy: function(){
        // for(let i = 0; i < 4; i++){
        //     // console.log(this.$refs['c-' + i])
        // }
    }
}
</script>

<style>
.charts-header-tab-title-active .selected{
    /* border-bottom: 4px solid white !important; */
    border-bottom: 4px solid white !important;
    margin-bottom: 0px;
    border-radius: 15px;
    width: 120%;
}
</style>

<style scoped>
.charts-header-tab-title {
    color: white;
    margin: 10px 30px 10px 30px;
    cursor: pointer;
    font-family: 'SourceSansProSemiBold', sans-serif !important;
}

.charts-header {
    padding: 0;
    padding-right: 50px;
    margin: 0;
    background-color: #0095B2;
    width: 100%;
    height: 100px;
    align-items: center;
    justify-content: start;
}

.chart {
    padding: 10px;
}

.mySpinner {
    position: absolute;
    z-index: 300;
    left: 0;
    top: 143px;
    width: 100%;
    height: calc(100% - 143px);
    overflow: auto;
    display: block;
    background-color: rgba(0,0,0,0.4);
}

.main-menu-bar {

    grid-template-columns: repeat(3, minmax(160px, 200px));
}
</style>


// WEBPACK FOOTER //
// src/components/Systems/GraphsModal.vue